<template>
  <div class="container-block" style="margin: 15px 0">
    <div class="mb20">
      <span class="fb fs16 mar10">额外添加原料</span>
      <a-tooltip>
        <template slot="title">
          额外添加的原料比例≤盘重的5%
        </template>
        <a-icon type="exclamation-circle" />
      </a-tooltip>
    </div>
    <a-table :columns="columns" :scroll="{x: 680,y:500}" :data-source="list" rowKey='name' :pagination="false">
      <template slot="fixed3" slot-scope="t">
        {{ t || t === 0 ? Number(t).toFixed(3) : t }}
      </template>
    </a-table>
  </div>
</template>
<script>
export default {
  props:{
    rowId:{
      type: String,
      default: ''
    },
    factoryId:{
      type: String,
      default: ''
    }
  },
  data(){
    return{
      list:[],
      columns: [
        {
          title: '原料名称',
          dataIndex: 'rawName',
          width: 150,
          ellipsis: true,
        },
        {
          title: '原料代码',
          dataIndex: 'rawCode',
          width: 120,
          ellipsis: true,
        },
        {
          title: '用量(%)',
          dataIndex: 'percentage',
          scopedSlots: {customRender: 'fixed3'},
          width: 100,
          ellipsis: true,
        },
        {
          title: '用量(批次量)',
          dataIndex: 'uasge',
          scopedSlots: {customRender: 'fixed3'},
          width: 80,
          ellipsis: true,
        },
        {
          title: '单位',
          dataIndex: 'unit',
          width: 120,
          ellipsis: true,
        },
      ],
    }
  },
  mounted(){
    this.getList()
  },
  methods:{
    getList(){
      let params = {
        formulaId:this.rowId,
      }
      if(this.rowId){
        this.$http.get('/nhf-app/archivedFormula/formulaRawExtraList',{params}).then(res => {
          let {success,data} = res;
          if(success){
            this.list = data
                .filter(item => item.isDeleted !== 1)
                .sort((a, b) => b.percentage - a.percentage);
          }else{
            this.$message.error('查询失败')
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.tableBox{
  padding: 0 20px;
}
</style>
